import { render, staticRenderFns } from "./create-orderable-modal.vue?vue&type=template&id=2bb3d573&lang=pug"
import script from "./create-orderable-modal.vue?vue&type=script&lang=js"
export * from "./create-orderable-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports